import { ProgressIndicator } from "@fluentui/react";
import { Layout, notification, Transfer, Modal, Spin } from "antd";
import { observer } from "mobx-react-lite";
import React, { useEffect, useState, useContext } from "react";
import { Persona, PersonaSize } from "@fluentui/react/lib/Persona";
import { Spinner, SpinnerSize } from "@fluentui/react/lib/Spinner";
import { Permission } from "./Permission";
import { Role } from "./Role";
import { RoleUser } from "./RoleUser";
import PermissionStore from "../store/permissionStore";
import AccountStore from "../../accountcenter/store/accountStore";
import { toJS } from "mobx";
const { Content, Sider } = Layout;
const _ = require("underscore");
export const PermissionBaseView = observer(() => {
  const permissionStore = useContext(PermissionStore);
  const accountStore = useContext(AccountStore);
  const [state, setState] = useState({
    mockData: [],
    users: [],
    targetKeys: [],
    selectedKeys: [],
    disableSave: true,
  });

  useEffect(() => {
    async function load() {
      if (!accountStore.users.size) {
        await accountStore.loadAllUsers();
      }
      await permissionStore.loadPriviledgesFromDB();

      const priviledges = [...permissionStore.priviledges.values()].map((p) =>
        toJS(p)
      );
      console.log(priviledges);

      if (priviledges.length) {
        await handleRoleClick(priviledges[0]);
      }
    }

    load();
  }, []);

  const handleRoleClick = async (role) => {
    if (role) {
      await fetData(role.groupId);
      permissionStore.selectedRole = role;

      let selKeys = _.pluck([...permissionStore.usersInRole.values()], "id");
      setState((s) => ({
        ...state,

        targetKeys: selKeys,
      }));
    }
  };
  const fetData = async (groupId) => {
    try {
      await permissionStore.getGroupPermissions(groupId);
    } catch (error) {
      notification.error({
        message: "SPARS Feedback",
        description: error.message,
      });
    }
  };
  const handleChange = (nextTargetKeys, direction, moveKeys) => {
    setState({ ...state, targetKeys: nextTargetKeys, disableSave: false });
  };

  const handleSelectChange = (sourceSelectedKeys, targetSelectedKeys) => {
    setState({
      ...state,
      selectedKeys: [...sourceSelectedKeys, ...targetSelectedKeys],
    });
  };

  const _filterOption = (inputValue, option) => {
    return (
      option.firstName.toUpperCase().indexOf(inputValue.toUpperCase()) > -1 ||
      option.lastName.toUpperCase().indexOf(inputValue.toUpperCase()) > -1
    );
  };

  const _save = async () => {
    const qusers = [...accountStore.users.values()].map((u) => toJS(u));
    let allTargetUsers = _.filter(qusers, (x) =>
      _.contains(state.targetKeys, x.id)
    );

    const allUsersInRoleIds = _.pluck(
      [...permissionStore.usersInRole.values()].map((u) => toJS(u)),
      "id"
    );
    const newlyAddedTargetUsers = _.filter(
      _.map(allTargetUsers, (user) => {
        if (!_.contains(allUsersInRoleIds, user.id)) {
          return user;
        }
      })
    );

    if (!newlyAddedTargetUsers.length) {
      notification["info"]({
        message: "SPARS Workflow Manager",
        description: `please select  users to map   to ${permissionStore?.selectedRole?.name?.toLowerCase()} account group`,
      });
      return;
    }
    console.log(newlyAddedTargetUsers);
    const { groupId } = permissionStore.selectedRole;
    await permissionStore.addUserstoRole(newlyAddedTargetUsers, groupId);
    permissionStore.showAddUserToRoleDialog = false;
  };
  return (
    <Layout>
      <Content>
        <Layout style={{ background: "#fff" }}>
          <Sider
            width={400}
            style={{ background: "#fff", paddingLeft: "20px", width: "30%" }}
          >
            <div className="ms-Grid" dir="ltr">
              <div className="ms-Grid-row ">
                <div className="ms-Grid-col ms-sm12">
                  {" "}
                  <Role onRoleClick={handleRoleClick} />
                </div>
              </div>
            </div>
          </Sider>

          <Content>
            <div
              className="ms-Grid"
              dir="ltr"
              style={{ width: "fit-content", maxWidth: "fit-content" }}
            >
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm5">
                  {" "}
                  <RoleUser />
                </div>
                <div className="ms-Grid-col ms-sm7">
                  {" "}
                  <div className="ms-Grid" dir="ltr">
                    {permissionStore.isworking && (
                      <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12">
                          {" "}
                          <ProgressIndicator
                            description="processing, please wait..."
                            styles={{ root: { textAlign: "center" } }}
                          ></ProgressIndicator>
                        </div>
                      </div>
                    )}
                    <div
                      className="ms-Grid-row"
                      style={{ paddingLeft: "24px" }}
                    >
                      <div className="ms-Grid-col ms-sm12">
                        {" "}
                        <Permission />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Modal
              visible={permissionStore.showAddUserToRoleDialog}
              onCancel={() => {
                permissionStore.showAddUserToRoleDialog = false;
              }}
              width={800}
              centered
              destroyOnClose={true}
              title={`Map user(s)  to ${permissionStore?.selectedRole?.name?.toLowerCase()} account group`}
              onOk={_save}
              okText="Save"
              okButtonProps={{ disabled: state.disableSave }}
            >
              <Spin
                spinning={
                  accountStore.isloadingUsers ||
                  permissionStore.isLoadingUsersInRole ||
                  permissionStore.isLoadinggrouppermissions
                }
                tip="Loading users and permissions..."
              >
                <div className="ms-Grid" dir="ltr">
                <div className="ms-Grid-row" style={{ marginTop: "10px" }}>
                  <div className="ms-Grid-col ms-sm12">
                    <Transfer
                      oneWay
                       width={700}
                      listStyle={{
                        width: 300,
                        height: 400,
                      }}
                      titles={[
                        "SPARS Users",
                        permissionStore?.selectedRole?.name + " group",
                      ]}
                      dataSource={_.sortBy(
                        [...accountStore.users.values()],
                        "fullName"
                      )}
                      showSearch
                      targetKeys={state.targetKeys}
                      selectedKeys={state.selectedKeys}
                      rowKey={(item) => item.id}
                      onChange={handleChange}
                      onSelectChange={handleSelectChange}
                      render={(item) => {
                        return {
                          label: (
                            <div className="ms-Grid">
                              <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm12">
                                  <Persona
                                    text={`${item.fullName} `}
                                    size={PersonaSize.size24}
                                    secondaryText={item.jobFunction}
                                    showSecondaryText={true}
                                  />
                                </div>
                              </div>
                            </div>
                          ),
                          value: item.firstName,
                        };
                      }}
                      filterOption={_filterOption}
                    />
                  </div>
                </div>
                {permissionStore.isAddingUsertoRole && (
                  <div className="ms-Grid-row" style={{ marginTop: "10px" }}>
                    <div className="ms-Grid-col ms-sm12">
                      <Spinner
                        label="Saving, please wait..."
                        ariaLive="assertive"
                        labelPosition="right"
                        size={SpinnerSize.large}
                      />
                    </div>
                  </div>
                )}
                </div>
              </Spin>
            </Modal>
          </Content>
        </Layout>
      </Content>
    </Layout>
  );
});

